import { webApi } from '@mi-front/api-clients';
import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { useVideoEditionsEditCategoryTabs } from '../../hooks/useVideoEditionsEditCategoryTabs';
import { CreateVideoEditionEditButton } from './CreateVideoEditionEditButton';
import { VideoEditionsCategoryChips } from './VideoEditionsCategoryChips';
import { VideoEditionsEditGrid } from './VideoEditionsEditGrid';
import { VideoEditionsTabSegmentEmpty } from './VideoEditionsTabSegmentEmpty';

export interface VideoEditionsEditListProps {
  edits: webApi.EnrichedVideoEditorEditListItemDto[];
  onCloneEdit: (edit: webApi.EnrichedVideoEditorEditListItemDto) => void;
  onEditMutationSuccess?: () => Promise<void> | void;
  renderPublishControl?: (edit: webApi.EnrichedVideoEditorEditListItemDto) => ReactNode;
  createWithAutoName: (currentEditCount: number) => void;
  isCreating: boolean;
}

/**
 * Chip navigation plus draft/generated grids when the source has at least one edit.
 */
export function VideoEditionsEditList({
  edits,
  onCloneEdit,
  onEditMutationSuccess,
  renderPublishControl,
  createWithAutoName,
  isCreating,
}: VideoEditionsEditListProps) {
  const { draftEdits, generatedEdits } = useVideoEditionsEditCategoryTabs(edits);

  return (
    <VideoEditionsCategoryChips
      header={
        <Box sx={{ ml: 2 }}>
          <CreateVideoEditionEditButton
            currentEditCount={edits.length}
            createWithAutoName={createWithAutoName}
            isCreating={isCreating}
          />
        </Box>
      }
      draftCount={draftEdits.length}
      generatedCount={generatedEdits.length}
      draftContent={
        draftEdits.length ? (
          <VideoEditionsEditGrid
            edits={draftEdits}
            onCloneEdit={onCloneEdit}
            onEditMutationSuccess={onEditMutationSuccess}
            renderPublishControl={renderPublishControl}
          />
        ) : (
          <VideoEditionsTabSegmentEmpty variant="draft" />
        )
      }
      generatedContent={
        generatedEdits.length ? (
          <VideoEditionsEditGrid
            edits={generatedEdits}
            onCloneEdit={onCloneEdit}
            onEditMutationSuccess={onEditMutationSuccess}
            renderPublishControl={renderPublishControl}
          />
        ) : (
          <VideoEditionsTabSegmentEmpty variant="generated" />
        )
      }
    />
  );
}
